"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Table.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TableCell(_ref) {
  var align = _ref.align,
      componentEl = _ref.componentEl,
      children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      margin = _ref.margin,
      isLabel = _ref.isLabel,
      valign = _ref.valign,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["align", "componentEl", "children", "className", "padding", "margin", "isLabel", "valign"]);

  var cssClasses = ['st_tablecell', "st_tablecell--align-" + align, "st_tablecell--valign-" + valign];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    padding: padding,
    margin: margin,
    cssClasses: cssClasses
  }); // this is set here and not as defaultProps
  // because Table.Row automatically makes the element th
  // if the row is a header row
  // and we cant detect that a user didn't set a componentEl
  // if we have defaultProps in place

  var Component = componentEl || 'td';

  if (isLabel) {
    cssClasses.push('st_tablecell--header');
  } else {
    cssClasses.push('st_tablecell--normal');
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

TableCell.propTypes = {
  /**
   * dom element or component to use, defaults to TD if it's a regular cell,
   * and TH if it's a header cell
   * */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** padding for cell. Setting this overrides defaults and does not extend them. */
  padding: utils.spacing.paddingProps,

  /** margin for cell, if any */
  margin: utils.spacing.marginProps,

  /** scope for table header, if any */
  scope: _propTypes["default"].oneOf(['row', 'col', 'rowgroup', 'colgroup']),

  /** whether this appears as a label, or regular text */
  isLabel: _propTypes["default"].bool,

  /** how to align cell contents */
  align: _propTypes["default"].oneOf(['left', 'right', 'center']),

  /** how to vertically align cell contents */
  valign: _propTypes["default"].oneOf(['baseline', 'top', 'bottom', 'middle'])
};
TableCell.defaultProps = {
  align: 'left',
  componentEl: null,
  className: null,
  margin: null,
  padding: {
    vertical: 'sm',
    horizontal: 'md'
  },
  scope: null,
  isLabel: false,
  valign: 'baseline'
};
TableCell.displayName = 'Table.Cell';
var _default = TableCell;
exports["default"] = _default;